import { graphQLClient, gql } from '@/core/config/graphqlClient'

const GET_APPLICATION_COUNT = gql`
  query applicationCount($hiringTeamId: ID!) {
    hiringTeam(hiringTeamId: $hiringTeamId) {
      applicationListCount(status: PENDING)
    }
  }
`

export const getApplicationCount = async hiringTeamId => {
  const data = await graphQLClient(GET_APPLICATION_COUNT, {
    hiringTeamId,
  })

  return data
}
